// extracted by mini-css-extract-plugin
export var divider = "_mo-0";
export var systemMessage = "_mo-1";
export var systemMessageWrapper = "_mo-2";